// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-pages-404-jsx": function componentSrcPages404Jsx() {
    return import("./../../src/pages/404.jsx"
    /* webpackChunkName: "component---src-pages-404-jsx" */
    );
  },
  "component---src-pages-about-jsx": function componentSrcPagesAboutJsx() {
    return import("./../../src/pages/about.jsx"
    /* webpackChunkName: "component---src-pages-about-jsx" */
    );
  },
  "component---src-pages-blockchain-platform-data-integration-jsx": function componentSrcPagesBlockchainPlatformDataIntegrationJsx() {
    return import("./../../src/pages/blockchain-platform/data-integration.jsx"
    /* webpackChunkName: "component---src-pages-blockchain-platform-data-integration-jsx" */
    );
  },
  "component---src-pages-blockchain-platform-index-jsx": function componentSrcPagesBlockchainPlatformIndexJsx() {
    return import("./../../src/pages/blockchain-platform/index.jsx"
    /* webpackChunkName: "component---src-pages-blockchain-platform-index-jsx" */
    );
  },
  "component---src-pages-blockchain-platform-scalability-jsx": function componentSrcPagesBlockchainPlatformScalabilityJsx() {
    return import("./../../src/pages/blockchain-platform/scalability.jsx"
    /* webpackChunkName: "component---src-pages-blockchain-platform-scalability-jsx" */
    );
  },
  "component---src-pages-blockchain-platform-smart-contracts-jsx": function componentSrcPagesBlockchainPlatformSmartContractsJsx() {
    return import("./../../src/pages/blockchain-platform/smart-contracts.jsx"
    /* webpackChunkName: "component---src-pages-blockchain-platform-smart-contracts-jsx" */
    );
  },
  "component---src-pages-business-anti-fraud-jsx": function componentSrcPagesBusinessAntiFraudJsx() {
    return import("./../../src/pages/business/anti-fraud.jsx"
    /* webpackChunkName: "component---src-pages-business-anti-fraud-jsx" */
    );
  },
  "component---src-pages-business-den-jsx": function componentSrcPagesBusinessDenJsx() {
    return import("./../../src/pages/business/den.jsx"
    /* webpackChunkName: "component---src-pages-business-den-jsx" */
    );
  },
  "component---src-pages-business-enterprise-nft-jsx": function componentSrcPagesBusinessEnterpriseNftJsx() {
    return import("./../../src/pages/business/enterprise-nft.jsx"
    /* webpackChunkName: "component---src-pages-business-enterprise-nft-jsx" */
    );
  },
  "component---src-pages-business-eternal-jsx": function componentSrcPagesBusinessEternalJsx() {
    return import("./../../src/pages/business/eternal.jsx"
    /* webpackChunkName: "component---src-pages-business-eternal-jsx" */
    );
  },
  "component---src-pages-business-factor-jsx": function componentSrcPagesBusinessFactorJsx() {
    return import("./../../src/pages/business/factor.jsx"
    /* webpackChunkName: "component---src-pages-business-factor-jsx" */
    );
  },
  "component---src-pages-business-index-jsx": function componentSrcPagesBusinessIndexJsx() {
    return import("./../../src/pages/business/index.jsx"
    /* webpackChunkName: "component---src-pages-business-index-jsx" */
    );
  },
  "component---src-pages-business-loyalty-and-rewards-jsx": function componentSrcPagesBusinessLoyaltyAndRewardsJsx() {
    return import("./../../src/pages/business/loyalty-and-rewards.jsx"
    /* webpackChunkName: "component---src-pages-business-loyalty-and-rewards-jsx" */
    );
  },
  "component---src-pages-business-lyceum-jsx": function componentSrcPagesBusinessLyceumJsx() {
    return import("./../../src/pages/business/lyceum.jsx"
    /* webpackChunkName: "component---src-pages-business-lyceum-jsx" */
    );
  },
  "component---src-pages-business-proof-systems-jsx": function componentSrcPagesBusinessProofSystemsJsx() {
    return import("./../../src/pages/business/proof-systems.jsx"
    /* webpackChunkName: "component---src-pages-business-proof-systems-jsx" */
    );
  },
  "component---src-pages-business-provable-contests-jsx": function componentSrcPagesBusinessProvableContestsJsx() {
    return import("./../../src/pages/business/provable-contests.jsx"
    /* webpackChunkName: "component---src-pages-business-provable-contests-jsx" */
    );
  },
  "component---src-pages-case-studies-covid-19-jsx": function componentSrcPagesCaseStudiesCovid19Jsx() {
    return import("./../../src/pages/case-studies/covid-19.jsx"
    /* webpackChunkName: "component---src-pages-case-studies-covid-19-jsx" */
    );
  },
  "component---src-pages-case-studies-emergency-management-system-jsx": function componentSrcPagesCaseStudiesEmergencyManagementSystemJsx() {
    return import("./../../src/pages/case-studies/emergency-management-system.jsx"
    /* webpackChunkName: "component---src-pages-case-studies-emergency-management-system-jsx" */
    );
  },
  "component---src-pages-case-studies-fintech-jsx": function componentSrcPagesCaseStudiesFintechJsx() {
    return import("./../../src/pages/case-studies/fintech.jsx"
    /* webpackChunkName: "component---src-pages-case-studies-fintech-jsx" */
    );
  },
  "component---src-pages-case-studies-index-jsx": function componentSrcPagesCaseStudiesIndexJsx() {
    return import("./../../src/pages/case-studies/index.jsx"
    /* webpackChunkName: "component---src-pages-case-studies-index-jsx" */
    );
  },
  "component---src-pages-case-studies-supply-chain-jsx": function componentSrcPagesCaseStudiesSupplyChainJsx() {
    return import("./../../src/pages/case-studies/supply-chain.jsx"
    /* webpackChunkName: "component---src-pages-case-studies-supply-chain-jsx" */
    );
  },
  "component---src-pages-community-index-jsx": function componentSrcPagesCommunityIndexJsx() {
    return import("./../../src/pages/community/index.jsx"
    /* webpackChunkName: "component---src-pages-community-index-jsx" */
    );
  },
  "component---src-pages-community-time-jsx": function componentSrcPagesCommunityTimeJsx() {
    return import("./../../src/pages/community/time.jsx"
    /* webpackChunkName: "component---src-pages-community-time-jsx" */
    );
  },
  "component---src-pages-contact-us-jsx": function componentSrcPagesContactUsJsx() {
    return import("./../../src/pages/contact-us.jsx"
    /* webpackChunkName: "component---src-pages-contact-us-jsx" */
    );
  },
  "component---src-pages-contests-open-source-money-contest-rules-jsx": function componentSrcPagesContestsOpenSourceMoneyContestRulesJsx() {
    return import("./../../src/pages/contests/open-source-money/contest-rules.jsx"
    /* webpackChunkName: "component---src-pages-contests-open-source-money-contest-rules-jsx" */
    );
  },
  "component---src-pages-contests-open-source-money-index-jsx": function componentSrcPagesContestsOpenSourceMoneyIndexJsx() {
    return import("./../../src/pages/contests/open-source-money/index.jsx"
    /* webpackChunkName: "component---src-pages-contests-open-source-money-index-jsx" */
    );
  },
  "component---src-pages-contests-sky-color-contest-rules-jsx": function componentSrcPagesContestsSkyColorContestRulesJsx() {
    return import("./../../src/pages/contests/sky-color/contest-rules.jsx"
    /* webpackChunkName: "component---src-pages-contests-sky-color-contest-rules-jsx" */
    );
  },
  "component---src-pages-contests-sky-color-index-jsx": function componentSrcPagesContestsSkyColorIndexJsx() {
    return import("./../../src/pages/contests/sky-color/index.jsx"
    /* webpackChunkName: "component---src-pages-contests-sky-color-index-jsx" */
    );
  },
  "component---src-pages-developers-index-jsx": function componentSrcPagesDevelopersIndexJsx() {
    return import("./../../src/pages/developers/index.jsx"
    /* webpackChunkName: "component---src-pages-developers-index-jsx" */
    );
  },
  "component---src-pages-developers-strategic-bounty-projects-git-jsx": function componentSrcPagesDevelopersStrategicBountyProjectsGitJsx() {
    return import("./../../src/pages/developers/strategic-bounty-projects/git.jsx"
    /* webpackChunkName: "component---src-pages-developers-strategic-bounty-projects-git-jsx" */
    );
  },
  "component---src-pages-developers-strategic-bounty-projects-index-jsx": function componentSrcPagesDevelopersStrategicBountyProjectsIndexJsx() {
    return import("./../../src/pages/developers/strategic-bounty-projects/index.jsx"
    /* webpackChunkName: "component---src-pages-developers-strategic-bounty-projects-index-jsx" */
    );
  },
  "component---src-pages-forbes-jsx": function componentSrcPagesForbesJsx() {
    return import("./../../src/pages/forbes.jsx"
    /* webpackChunkName: "component---src-pages-forbes-jsx" */
    );
  },
  "component---src-pages-index-jsx": function componentSrcPagesIndexJsx() {
    return import("./../../src/pages/index.jsx"
    /* webpackChunkName: "component---src-pages-index-jsx" */
    );
  },
  "component---src-pages-open-source-money-jsx": function componentSrcPagesOpenSourceMoneyJsx() {
    return import("./../../src/pages/open-source-money.jsx"
    /* webpackChunkName: "component---src-pages-open-source-money-jsx" */
    );
  },
  "component---src-pages-terms-jsx": function componentSrcPagesTermsJsx() {
    return import("./../../src/pages/terms.jsx"
    /* webpackChunkName: "component---src-pages-terms-jsx" */
    );
  },
  "component---src-templates-article-jsx": function componentSrcTemplatesArticleJsx() {
    return import("./../../src/templates/article.jsx"
    /* webpackChunkName: "component---src-templates-article-jsx" */
    );
  },
  "component---src-templates-blog-jsx": function componentSrcTemplatesBlogJsx() {
    return import("./../../src/templates/blog.jsx"
    /* webpackChunkName: "component---src-templates-blog-jsx" */
    );
  }
};